import { getToken } from "@/utils/auth";
import {HttpManager} from "@/api";
export default {
  state: {
    token: getToken(), // 用户是否登录
    userId: "", // ID
    username: "", // 名字
    userPic: "", // 图片
  },
  getters: {
    token: (state) => state.token,
    userId: (state) => state.userId,
    username: (state) => state.username,
    userPic: (state) => state.userPic,
  },
  mutations: {
    setToken: (state, token) => {
      state.token = token;
    },
    setUserId: (state, userId) => {
      state.userId = userId;
    },
    setUsername: (state, username) => {
      state.username = username;
    },
    setUserPic: (state, userPic) => {
      state.userPic = userPic;
    },
  },
  actions: {
    // 获取用户信息
     async GetInfo({commit, state}) {
       const result = ((await HttpManager.userInfo()) as ResponseBody);
       commit('setUserId', result.data[0].id);
       commit('setUsername', result.data[0].username);
       commit('setUserPic', result.data[0].avator);
       return result;
    },
  }
};
